export const MAIN_GREEN = "#18ba66";
